module.exports = __webpack_public_path__ + "static/img/xinyang.b9e9876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinyang.jpg
// module id = Uwb0
// module chunks = 1